import type { BillingDocument } from '@/types/Order.interface';

/**
 * i18n key for the document type the ÖKC reported. Token's own list: 0 satış
 * fişi, 9000 avans, 9002 cari tahsilat, 9005 fatura, 9006 e-fatura and 9007
 * e-arşiv bilgi fişi, 9008 eczane; 1 is what an issued e-Belge reports. Null for
 * anything else, so the raw number can be shown instead of a wrong label.
 */
const DOCUMENT_TYPE_KEYS: Record<number, string> = {
  0: 'order.billing.type.receipt',
  1: 'order.billing.type.eBelge',
  9000: 'order.billing.type.advance',
  9002: 'order.billing.type.collection',
  9005: 'order.billing.type.invoiceInfo',
  9006: 'order.billing.type.eInvoiceInfo',
  9007: 'order.billing.type.eArchiveInfo',
  9008: 'order.billing.type.pharmacy'
};

export const billingDocumentTypeKey = (
  documentType: number | null | undefined
): string | null =>
  documentType !== null &&
  documentType !== undefined &&
  Object.prototype.hasOwnProperty.call(DOCUMENT_TYPE_KEYS, documentType)
    ? DOCUMENT_TYPE_KEYS[documentType]
    : null;

/** Worth a row: a document number, a buyer or an open balance. */
export const billingDocumentHasContent = (
  document: Pick<BillingDocument, 'documentNo' | 'customer' | 'receivable'>
): boolean =>
  Boolean(document.documentNo || document.customer || document.receivable);
